import Title from "../../components/title";
import BlogListCard from "../../components/Blog/ListCard";
import helpers from "../../utils/helpers";
import urls from "../../constants/api-endpoints";
import axios from "axios";
import Link from "next/link";
import Input from "../../components/General/Input";
import { useDispatch, useSelector } from "react-redux";
import { getBlogList } from "../../store/CoreSlice";
import { useEffect, useRef, useState } from "react";
import InfiniteLoader from "../../components/General/InfiniteLoader";
import { MixpanelTracking } from "../../MixPanel";

function BlogHome() {    
    const dispatch : any = useDispatch();
    let { blogList } = useSelector((state : any) => state.core);
    const [searchInput, setSearchInput] = useState('');
    const [showSearchResults, setShowSearchResults] = useState(false);
    const currentPage = useRef(1);

    useEffect(() => {
        const params = {
            page : 1,
            page_size : 30
        }
        dispatch(getBlogList(params));
        MixpanelTracking.getInstance().pageViewed({});
    }, [])

    const handleSearch = (event : any) => {
        setSearchInput(() => event.target.value);
        setShowSearchResults(() => true);
        dispatch(getBlogList({
            page : 1,
            page_size : 10,
            search : event.target.value
        }));
    }

    const loadMoreBlogs = () => {                        
        currentPage.current = currentPage.current + 1;
        
        if(blogList.data.next) {
            dispatch(getBlogList({
                page : currentPage.current,
                page_size : 30,
                type : 'append'
            }));
        }
    }

    return (
        <div className="py-10 min-h-[50vh]">
            <Title title="Blogs" />
            <div className="flex items-center justify-center flex-col md:w-[65%] lg:w-[50%] md:mx-auto">

                {
                    blogList.list.length > 1 &&
                    <div className="ml-auto w-[50%] relative mb-2">
                        <Input 
                            outerProperties = "border rounded h-[40px]"
                            properties = "rounded h-[38px]"
                            placeholder = "Search By Blog"
                            suffix = {
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-[gray] mr-1">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                                </svg>
                            }
                            search
                            searchResults = {
                                showSearchResults &&
                                blogList.searchList.map((blog : any) => (
                                    <Link className="block rounded py-2 my-1 px-2 hover:bg-[#D4D9E7]" href={`/blogs/${blog.slug}`} key={blog.id}>
                                        {blog.title}
                                    </Link>
                                ))
                            }
                            onChange = {handleSearch}
                            value = {searchInput}
                            onBlur = { () => {
                                setTimeout(() => {
                                    setShowSearchResults(() => false)   
                                }, 300)
                            }}
                        />
                    </div>
                }
            
                {
                    blogList.list.length > 0 &&
                    <>
                        <div className="w-full mb-[30px]" onClick={() => console.log(blogList)}>
                            <img className="w-full" src={blogList.list[0].title_image} alt={blogList.list[0].title} />
                        </div>

                        <div className="px-[20px] text-center">
                            <h1 className="text-[36px] font-semibold cursor-pointer hover:underline"> 
                                <Link href={`/blogs/${blogList.list[0].slug}`}>
                                    {blogList.list[0].title}     
                                </Link>
                            </h1>
                            <small className="font-light text-[16px] mt-[24px] inline-block"> {blogList.list[0].brief_description} </small>
                        </div>
                    </>
                }
            </div>
            
            {
                blogList.list.length > 0 &&
                <div className="md:w-[45%] md:mx-auto">
                    <div className="h-[3px] w-full lg:w-[95%] lg:mx-auto bg-[#000000] my-[50px]" />
                    <h1 className="font-semibold text-[32px] mb-[28px] text-center">All articles</h1>                

                    <div className="px-[20px] md:grid md:grid-cols-2 gap-x-[30px] gap-y-[50px]">
                        {
                            blogList.list.map((blog : any, index : number) => (
                                index !== 0 &&
                                <div key={blog.id} className="mb-[40px] md:mb-0 cursor-pointer">
                                    <BlogListCard 
                                        data = {blog} 
                                    />
                                </div>
                            ))
                        }
                    </div>

                    <div className="text-center mt-10">
                        <InfiniteLoader 
                            show = {blogList.data.next && true} 
                            message = {"Loading More..."}
                            actionOnShow = {loadMoreBlogs}
                            extras = {blogList}
                        />
                    </div>

                </div>
            }

            {
                blogList.list.length === 0 &&
                <h1 className="flex items-center justify-center text-3xl text-theme-black"> No Blogs Yet! </h1>
            }

        </div>
    )
}

export default BlogHome